import React from 'react';
import PropTypes from 'prop-types';
import { X } from 'lucide-react';
import Button from '../Button';

/**
 * FilterChips — the active choices under the bar (internal): one gray
 * tertiary Button per choice (X removes it) and "Clear all". Desktop only —
 * hidden below 1024px (Filter.css), where the drawer does the clearing.
 */
const FilterChips = ({ chips, onRemove, onClearAll, labels }) => (
  <div className="ds-filter__chips">
    <ul className="ds-filter__chip-list" aria-label={labels.activeFilters}>
      {chips.map((chip) => (
        <li key={chip.key} className="ds-filter__chip">
          <Button
            size="tertiary"
            variant="gray"
            iconRight={<X size={20} />}
            aria-label={labels.removeChip(chip.label)}
            onClick={() => onRemove(chip)}
          >
            {chip.label}
          </Button>
        </li>
      ))}
    </ul>
    <Button size="tertiary" variant="text" className="ds-filter__clear-all" onClick={onClearAll}>
      {labels.clearAll}
    </Button>
  </div>
);

FilterChips.propTypes = {
  chips: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  onRemove: PropTypes.func.isRequired,
  onClearAll: PropTypes.func.isRequired,
  labels: PropTypes.object.isRequired,
};

export default FilterChips;
